import { API_CALL } from '../../middleware/api';

export const GET_MY_ORGS = 'egt-my-orgs';
export const GET_MY_ORGS_RESULT = `${GET_MY_ORGS}/result`;
export const GET_MY_ORGS_ERROR = `${GET_MY_ORGS}/error`;

export const SET_ORG_FILTER = 'set-org-filter';

export const actions = {
  getMyOrgs: () => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: 'portal/v1/organizations/me/',
    },
    type: GET_MY_ORGS,
  }),
  setOrgFilter: orgIds => ({
    type: SET_ORG_FILTER,
    orgIds,
  }),
};

export const OrgFilterReducer = (state = {orgIds: []}, action) => {
  switch (action.type) {
    case SET_ORG_FILTER:
      return {
        ...state,
        orgIds: action.orgIds || []
      };

    case GET_MY_ORGS_RESULT:
      return {
        ...state,
        orgs: action.response.data,
      };
    case GET_MY_ORGS_ERROR:
      return {
        ...state,
        orgs: [],
      };
    case GET_MY_ORGS:
      return {
        ...state,
        orgs: [],
      };

    default:
      return state;
  }
};
